import { isPlatformBrowser } from '@angular/common';
import { FreelancerHttpConfig, } from '@freelancer/freelancer-http';
import { Location } from '@freelancer/location';
import { PerformanceTracking } from '@freelancer/tracking';
import * as i0 from "@angular/core";
import * as i1 from "../tracking/performance-tracking.service";
import * as i2 from "../freelancer-http/freelancer-http.config";
import * as i3 from "../location/location.service";
import * as i4 from "@angular/common";
var RedirectToPhp = /** @class */ (function () {
    // We don't want to push states to the history if no route has been loaded,
    // i.e. if the webapp performed a redirect on start
    function RedirectToPhp(performanceTracking, freelancerHttpConfig, location, platformId, baseHref) {
        this.performanceTracking = performanceTracking;
        this.freelancerHttpConfig = freelancerHttpConfig;
        this.location = location;
        this.platformId = platformId;
        this.baseHref = baseHref;
    }
    RedirectToPhp.prototype.doRedirect = function (url) {
        // Add ?w=f (webapp false) search param to the URL in order to force the
        // PVP variant on routes serving both webapp & php pages
        var redirectUrl;
        var u = this.baseHref
            ? new URL("" + this.location.origin + this.baseHref.replace(/\/$/, '') + url)
            : new URL("" + this.location.origin + url);
        var s = u.searchParams;
        s.set('w', 'f');
        u.search = s.toString();
        redirectUrl = u.toString();
        if (isPlatformBrowser(this.platformId)) {
            // Log the redirect time
            console.log("redirected in " + Math.round(window.performance.now()) + " ms");
            this.performanceTracking.mark('webapp_php_redirect', true);
        }
        if (this.location.hostname === 'localhost') {
            redirectUrl = "" + this.freelancerHttpConfig.baseUrl + u.pathname + u.search + u.hash;
        }
        return this.location.redirect(redirectUrl);
    };
    RedirectToPhp.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RedirectToPhp_Factory() { return new RedirectToPhp(i0.ɵɵinject(i1.PerformanceTracking), i0.ɵɵinject(i2.FREELANCER_HTTP_CONFIG), i0.ɵɵinject(i3.Location), i0.ɵɵinject(i0.PLATFORM_ID), i0.ɵɵinject(i4.APP_BASE_HREF, 8)); }, token: RedirectToPhp, providedIn: "root" });
    return RedirectToPhp;
}());
export { RedirectToPhp };
